import React, { useState } from "react";
import { translations } from "../translations";

const OPTION_LABELS = ["A", "B", "C", "D"];

const QuestionScreen = ({
  question,
  index,
  total,
  selected,
  onSelect,
  onNext,
  lang,
}) => {
  const t = translations[lang];
  const [typedAnswer, setTypedAnswer] = useState(selected || "");

  const handleTextChange = (e) => {
    const val = e.target.value;
    setTypedAnswer(val);
    onSelect(val);
  };

  const sectionKey = question.section.replace(/\s+/g, "").charAt(0).toLowerCase()
    + question.section.replace(/\s+/g, "").slice(1);
  const localizedSection = t[sectionKey] || question.section;

  return (
    <div className="page-wrap exam-wrap">
      <div className="card question-card question-card-animate">
        <div className="question-dots">
          {Array.from({ length: total }).map((_, i) => (
            <span
              key={i}
              className={`question-dot ${i < index ? "done" : ""} ${i === index ? "active" : ""}`}
            />
          ))}
        </div>

        <div className="question-card-header">
          <span className="question-section-badge">{localizedSection}</span>
          <span className="question-step-pill">
            {t.questionProgress} {index + 1} / {total}
          </span>
        </div>

        <div className="question-content">
          <p className="question-text">{question.content.question}</p>

          {question.type === "text" ? (
            <textarea
              className="text-answer-input"
              placeholder={t.writeAnswer}
              value={typedAnswer}
              onChange={handleTextChange}
            />
          ) : (
            <div className="options-grid">
              {question.content.options.map((opt, i) => (
                <button
                  type="button"
                  key={i}
                  className={`option-item ${selected === opt ? "selected" : ""}`}
                  onClick={() => onSelect(opt)}
                >
                  <span className="option-letter">{OPTION_LABELS[i] || i + 1}</span>
                  <span className="option-text">{opt}</span>
                  {selected === opt && <span className="option-check">✓</span>}
                </button>
              ))}
            </div>
          )}
        </div>

        <button
          type="button"
          className="btn-primary btn-lg btn-full quiz-next-btn"
          onClick={onNext}
          disabled={!selected}
        >
          {index === total - 1 ? t.submit : t.next}
          <span className="btn-arrow">→</span>
        </button>
      </div>
    </div>
  );
};

export default QuestionScreen;
